import { mapToCanActivate, Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import {
   AuthGuardService,
   AuthGuardRegistrationService,
   CanActivateGuardService,
   PublicOnlyGuardService
} from '@appShared/services';
import { IFramePlayerComponent } from '@appShared/components/iframe-player/iframe-player.component'
import {
    AuthResponseComponent,
    ErrorComponent,
   LandingComponent,
   LoginFailedComponent,
   PageNotFoundComponent,
   ShellComponent,
   UnauthorizedComponent,
   WeHaveMovedComponent
} from '@appContainers/index'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { environment } from '@appEnvironments/environment';
import { CONTENT_ROUTES } from './content/content.routes';

export const APP_ROUTES: Routes = [
   {
      path: '',
      component: ShellComponent,
      children: [
         {
            path: '',
            canActivate: [PublicOnlyGuardService],
            component: LandingComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.weHaveMoved.baseUri,
            canActivate: [PublicOnlyGuardService],
            component: WeHaveMovedComponent
         },
         ...CONTENT_ROUTES, /* If NOT lazy-loading */
         //{
         //   path: SITE_DIRECTORY_ROUTES.content.baseUri,
         //   canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService],
         //   loadChildren: () =>
         //      import('./content/content.routes').then(mod => mod.CONTENT_ROUTES)
         //},
         {
            path: environment.playerUri,
            canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService],
            component: IFramePlayerComponent
         },
         //...MEMBER_ROUTES, /* If NOT lazy-loading */
         {
            path: SITE_DIRECTORY_ROUTES.member.baseUri,
            canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService],
            loadChildren: () =>
               import('./member/member.routes').then(mod => mod.MEMBER_ROUTES)
         },
         //...REGISTRATION_LANDING_ROUTES, /* If NOT lazy-loading */
         {
            path: SITE_DIRECTORY_ROUTES.registrationLanding.baseUri,
            loadComponent: () =>
               import('./containers/registration-landing/registration-landing.component').then(
                  mod => mod.RegistrationLandingComponent
               )
         },
         {
            path: SITE_DIRECTORY_ROUTES.registration.baseUri,
            canActivate: [CanActivateGuardService, MsalGuard, AuthGuardRegistrationService],
            loadComponent: () => import('./containers/registration/registration.component').then(
               mod => mod.RegistrationComponent
            )
         },
         {
            /* keeping this path in case old email still have /complete-registration link */
            path: SITE_DIRECTORY_ROUTES.completeRegistration.baseUri,
            canActivate: [CanActivateGuardService, MsalGuard, AuthGuardRegistrationService],
            loadComponent: () => import('./containers/registration/registration.component').then(
               mod => mod.RegistrationComponent
            )
         },
         //{ //TODO - this will go away - replaced by EntraID
         //{
         //   path: SITE_DIRECTORY_ROUTES.signUp.baseUri,
         //   canActivate: mapToCanActivate([RegistrationGuardService]),
         //   loadComponent: () => import('./containers/sign-up/sign-up.component').then(
         //      mod => mod.SignUpComponent
         //   )
         //},
         {
            path: SITE_DIRECTORY_ROUTES.error.baseUri,
            component: ErrorComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.loginFailed.baseUri,
            component: LoginFailedComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.unauthorized.baseUri,
            component: UnauthorizedComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.auth.baseUri,
            component: AuthResponseComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.pageNotFound.baseUri,
            component: PageNotFoundComponent
         },
         { path: '**', redirectTo: SITE_DIRECTORY_ROUTES.pageNotFound.baseUri, pathMatch: 'full' }
      ]
   }
]
